import React, { useMemo } from 'react';
import { ThemedButton } from '../../../../shared/components/themed-button';
import { useStyles } from './style';
import { Typography } from '@material-ui/core';
import { PlanTypes } from '../CurrentPlan';
import { LocalStorageService } from '../../../../shared/services/localStorage.service';
import { useGetStripeProductsQuery } from '../../../../api/stripe-product';
import { formatCurrency } from '../../../../shared/helpers/format-currency';

interface Props {
  isYearly: boolean;
  newPlan: PlanTypes;
  onClose: () => void;
}

export const SubscriptionActivatedPopup: React.FC<Props> = ({ isYearly, newPlan, onClose }) => {
  const classes = useStyles();
  const countryCode = LocalStorageService.getItem('country') || 'au';
  const { data: products } = useGetStripeProductsQuery({country_code: countryCode});

  const stripePrice = useMemo(() => {
    const product = products?.stripe_products?.find(
      (p) => p.product_key === newPlan
    );

    if(!product) {
      return null;
    }

    const price = product.stripe_prices.find(
      (p) => p.interval === (isYearly ? 'year' : 'month')
    );

    if(!price) {
      return null;
    }

    return price;
  }, [isYearly, newPlan, products]);

  const productPrice = useMemo(() => {
    if(stripePrice === null) {
      return 0;
    }

    return stripePrice.unit_amount;
  }, [stripePrice]);

  return (
    <div className={classes.root}>
      <Typography className={classes.title}>Subscription Activated!</Typography>
      <Typography className={classes.subTitle}>
        Thank you for reactivating your Open Pantry plan.<br />
        Your subscription is now live and your account is fully unlocked.
      </Typography>

      <div className={classes.planContainer}>
        <Typography className={classes.subTitle}><strong>Plan:</strong> {
          newPlan === 'pro_lite'
            ? 'Pro - Lite Plan'
            : 'Pro - Standard Plan (Recommended)'
        }</Typography>
        <Typography className={classes.subTitle}><strong>Billing:</strong> {formatCurrency(productPrice/100, 0, products?.price_country_code, products?.price_country_currency)}{isYearly ? '/year (Save 20%)' : '/month'}</Typography>
      </div>

      <Typography className={classes.subTitle}>
        You can now access your dashboard, manage orders, and start using all your plan features.
      </Typography>

      <ThemedButton
        className={classes.greatBtn}
        onClick={onClose}
        title='Great'
        buttonStyle='blueDarkButton'
        width={200}
      />
    </div>
)};
